// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from "jquery";
import 'fg-frontend/plugins/jquery.gtmHandler';

let afterAjaxRequest = false;
$(document).on('ajaxComplete', function(){
	afterAjaxRequest = true;
});

export default class CustomGtmHandler extends WebComponent {
	didMount() {
		// Do eventType se načte hodnota z event type např.:
		// <dataset>
        //    <is>CustomGtmHandler</is>
        //    <eventType>fgSkoleniZapis</eventType>
		// </dataset>
        let eventType = this.element.dataset.eventType;
        let _self = this.element;

		$(this.element).gtmHandler({
			'debug': false,
			'ajaxLoad': afterAjaxRequest,
		});

        // Vybere funkci pro eventu z eventType
        switch (eventType) {
			case 'fgZadaniEmailuNLKariera':
				fgZadaniEmailuNLKariera();
				break;
			case 'fgHledaniPobocekKariera':
				fgHledaniPobocekKariera();
				break;
			// case 'fgOdeslaniKontaktnihoFormulareUspesne':
			// 	fgOdeslaniKontaktnihoFormulareUspesne();
			// 	break;
			// case 'fgOdeslaniKontaktnihoFormulareNeuspesne':
			// 	fgOdeslaniKontaktnihoFormulareNeuspesne();
			// 	break;
			case 'fgInterakceSeStrankou':
				fgInterakceSeStrankou();
				break;
			case 'fgInterakcePatickaEmail':
				fgInterakcePatickaEmail();
				break;
			case 'fgInterakcePatickaKontakty':
				fgInterakcePatickaKontakty();
				break;
            default:
                break;
        }

        function fgZadaniEmailuNLKariera() {
			_self.onclick = function(){
				dataLayer.push({
					'event': 'fgWebAnalytics',
					'fgVarCat': 'Interakce se stránkou',
					'fgVarAct': 'Registrace NL',
					'fgVarLbl': window.location.href
				});
			};
		}

        function fgHledaniPobocekKariera() {
			let selectedCity = _self.innerHTML;
			let cities = document.querySelector('.city-select.options').children;

			for (let city of cities) {
				city.onclick = function () {
					if (selectedCity != this.children[0].innerHTML) {
						selectedCity = this.children[0].innerHTML;
						dataLayer.push({
							'event': 'fgHledaniPobocekKariera',
							'fgAkce': selectedCity
						});
					}
				}
			}
		}

		// function fgOdeslaniKontaktnihoFormulareUspesne() {
		// 	_self.onclick = function(){
		// 		dataLayer.push({
		// 			'event': 'fgWebAnalytics',
		// 			'fgVarCat': 'Odeslání formuláře - Kariéra',
		// 			'fgVarAct': 'Odesláno úspěšně',
		// 			'fgVarLbl': document.getElementsByTagName('h1')[0].innerHTML
		// 		});
		// 	};
		// }
		//
		// function fgOdeslaniKontaktnihoFormulareNeuspesne() {
		// 	_self.onclick = function(){
		// 		dataLayer.push({
		// 			'event': 'fgWebAnalytics',
		// 			'fgVarCat': 'Odeslání formuláře - Kariéra',
		// 			'fgVarAct': 'Odesláno neúspěšně',
		// 			'fgVarLbl': document.getElementsByTagName('h1')[0].innerHTML
		// 		});
		// 	};
		// }

		// function fgInterakceSeStrankou() {
		// 	_self.onclick = function(){
		// 		dataLayer.push({
		// 			'event': 'fgWebAnalytics',
		// 			'fgVarCat': 'Interakce se stránkou',
		// 			'fgVarAct': 'Proklik tlačítka' + _self.innerHTML,
		// 			'fgVarLbl': window.location.href
		// 		});
		// 	};
		// }

		function fgInterakcePatickaEmail(){
			_self.onclick = function(){
				dataLayer.push({
					'event': 'fgWebAnalytics',
					'fgVarCat': 'Interakce se stránkou',
					'fgVarAct': 'Proklik emailu nad patičkou',
					'fgVarLbl': window.location.href
				});
			};
		}

		function fgInterakcePatickaKontakty() {
			_self.onclick = function(){
				dataLayer.push({
					'event': 'fgWebAnalytics',
					'fgVarCat': 'Interakce se stránkou',
					'fgVarAct': 'Proklik kontakty nad patičkou',
					'fgVarLbl': window.location.href
				});
			};
		}
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/CustomGtmHandler.js